<nav>
  <div class="buttons-container">
    <div
      class="btn-next active-completion-title"
      data-success="Changes Applied Successfully!"
      data-failure="Failed to Apply Changes!"
      [class.hidden]="applyHidden"
      [class.disabled]="applyDisabled"
      [class.succeeded]="applyState == ApplyEnum.Succeeded"
      [class.failed]="applyState == ApplyEnum.Failed"
      (click)="!applyDisabled && apply.emit()"
    >
      Apply
    </div>

    <div class="next-prev-container">
      <div class="btn-back" [class.hidden]="backHidden" (click)="back.emit()">
        <a class="rounded-btn-prev" role="button"></a>
        <span class="back">Back</span>
      </div>
      <div
        class="btn-back"
        [class.hidden]="nextHidden"
        [class.disabled]="nextDisabled"
        (click)="!nextDisabled && next.emit()"
      >
        <span class="back">Next</span>
        <a class="rounded-btn-prev rounded-btn-next" role="button"></a>
      </div>
    </div>
  </div>
</nav>
